// Import Packages
import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';

// Import Material UI Elements
import IndeterminateCheckBoxIcon from '@material-ui/icons/IndeterminateCheckBox';
import { Select, MenuItem } from '@material-ui/core';
import Checkbox from "@material-ui/core/Checkbox";
import { withStyles } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import AddCircleIcon from '@material-ui/icons/AddCircle';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AddBoxIcon from '@material-ui/icons/AddBox';
import IndeterminateCheckBoxOutlinedIcon from '@material-ui/icons/IndeterminateCheckBoxOutlined';

// Import Components
import { Condition } from '../../../../FlowConfigurationInputs/ConditionModal/ConditionModal'
import ConfigurationForm from '../../../../FlowConfigurationForms/index'

// Import Function Objects | Arrays
import { functionNames, actionList } from '../functions/functions'

// Import CSS
import './Action.css'

const useStyles = makeStyles((theme) => ({
    header: {
        justifyContent: 'space-between',
        color: 'white',
        backgroundColor: 'var(--black-pearl)',
        fontSize: '12px',
        padding: '8px'
    }
}));

// const actionNames = [
//     { value: 'REPLACE', label: 'Replace', type: 'string' },
//     { value: 'TRIM', label: 'Trim', type: 'string' },
//     { value: 'APPEND', label: 'Append', type: 'object' }
// ]

// export const actionList = {
//     REPLACE: {
//         libraryName: 'STRING',
//         actionName: 'REPLACE',
//         fields: {
//             sourceString: { value: '-', defaultValue: true },
//             set: { value: '-', type: 'VARIABLEPICKER' } // , defaultValue: true 
//         },
//         isDebugging: false,
//         name: 'REPLACE'
//     },
//     TRIM: {
//         libraryName: 'STRING',
//         actionName: 'TRIM',
//         fields: {
//             sourceString: { value: '-', defaultValue: true },
//             set: { value: '-', type: 'VARIABLEPICKER' } // , defaultValue: true
//         },
//         isDebugging: false,
//         name: 'TRIM'
//     },
//     APPEND: {
//         libraryName: 'OBJECT',
//         actionName: 'APPEND',
//         fields: {
//             set: { value: '-', defaultValue: true } // , defaultValue: true
//         },
//         isDebugging: false,
//         name: 'APPEND'
//     }
// }

const GreenCheckbox = withStyles({
    root: {
        color: green[400],
        '&$checked': {
            color: green[600],
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

function Action({ actions, setActions, index, variables, setOpenVariable, variableRender, sourceValue, field }) {
    const { t } = useTranslation();

    const [hasCondition, setHasCondition] = useState(false);
    const [actionName, setActionName] = useState('');
    const [selectedAction, setSelectedAction] = useState(null);
    const [conditions, setConditions] = useState([]);
    const classes = useStyles();
    const conditionBackup = useRef();

    const label = 'CONTENT.CONFIGURATION-FORM.ADVANCED-ACTIONS.ADVANCED-ASSIGN.';



    useEffect(() => {
        if (actions[index].name) {
            // if (field.conditions && field.conditions.length >= index) { // aksiyona ait index varsa
            //     setHasCondition(true);
            // }
            //field.conditions[actions[index].name]
            if (actions[index].conditions && actions[index].conditions.length) {
                if (!hasCondition) {
                    setHasCondition(true);
                }
                setConditions(actions[index].conditions);
            } else {
                setConditions([]);
                if (hasCondition) {
                    setHasCondition(false);
                }
            }
            let name = `${actions[index].libraryName}-${actions[index].actionName}`;
            //let action = changeSelectedAction(name);
            let action = JSON.parse(JSON.stringify(actionList[name]))
            for (const key in action.fields) {
                if (action.fields[key].defaultValue) {
                    actions[index].fields[key].value = sourceValue;
                }
            }
            // Object.keys(action.fields).forEach((key) => {
            //     if (action.fields[key].defaultValue) {
            //         actions[index].fields[key].value = sourceValue;
            //     }
            // })

            setSelectedAction(JSON.parse(JSON.stringify(actions[index])));
            //let name = `${actions[index].libraryName}-${actions[index].actionName}`
            setActionName(`${actions[index].libraryName}-${actions[index].actionName}`);


            // if (actions[index].name === 'CONDITION') { // has condition true
            //     setHasCondition(true);
            //     setConditions(actions[index].children[0].fields.conditions.value); // set conditions
            //     if (actions[index].children && actions[index].children[0].children[0]) {
            //         setSelectedAction(actions[index].children[0].children[0]);
            //         setActionName(actions[index].children[0].children[0].name);
            //     }
            // } else {
            //     setSelectedAction(actions[index]);
            //     setActionName(actions[index].name);
            // }
        }
    }, [actions]);

    const changeSelectedAction = (name) => {
        let ac = JSON.parse(JSON.stringify(actionList[name]))
        for (const key in ac.fields) {
            if (ac.fields[key].defaultValue) {
                ac.fields[key].value = sourceValue;//action.fields[key].value.replace('-', sourceValue);
            }
        }
        // Object.keys(action.fields).forEach((key) => {
        //     if (action.fields[key].defaultValue) {
        //         action.fields[key].value = sourceValue;//action.fields[key].value.replace('-', sourceValue);
        //     }
        // })

        return ac;
    }

    const changeHasCondition = (checked) => {
        setHasCondition(!hasCondition)
        let _actions = [...actions];
        if (checked) {
            let c = []
            if (conditions.length < 1) {
                c = addCondition(true);
            } else {
                c = [...conditions];
            }

            _actions[index].conditions = c;


        } else {
            delete _actions[index].conditions
            // if (actionData[index].name) {
            //     if (actionData[index].name === 'CONDITION') {
            //         if (actionData[index].children[0].children.length > 0) {
            //             actionData[index] = actionData[index].children[0].children[0]
            //         } else {
            //             actionData[index] = {};
            //         }
            //         setActions(actionData);
            //     }
            // }
        }
        setActions(_actions);
    }

    // const changeHasCondition = (checked) => {
    //     setHasCondition(!hasCondition)
    //     let actionData = [...actions];
    //     if (checked) {
    //         let c = []
    //         if (conditions.length < 1) {
    //             c = addCondition(true);
    //         } else {
    //             c = [...conditions];
    //         }

    //         let condition = {
    //             "flow": "rowCol",
    //             "name": "CONDITION",
    //             "type": "condition",
    //             "children": [
    //                 {
    //                     "name": "IF",
    //                     "type": "groupable",
    //                     "fields": { conditions: { type: "CONDITION", value: c } },
    //                     "children": [],
    //                     "actionName": "IF",
    //                     "action_name": "IF",
    //                     "isDebugging": false,
    //                     "libraryName": "CONDITION",
    //                     "action_label": "IF",
    //                     "libraryLabel": "CONDITION",
    //                     "library_name": "CONDITION",
    //                     "library_label": "CONDITION",
    //                     "conditionGroupId": "8b26a530-6e34-4b96-b506-3e40d44f99f9"
    //                 }
    //             ],
    //             "action_name": "CONDITION",
    //             "flow_behavior": [
    //                 "vertical",
    //                 "groupable"
    //             ]
    //         }


    //         if (actionData[index].name && actionData[index].name !== 'CONDITION') {
    //             condition.children[0].children.push(actionData[index]);
    //         }
    //         actionData[index] = condition;
    //         setActions(actionData);

    //     } else {
    //         if (actionData[index].name) {
    //             if (actionData[index].name === 'CONDITION') {
    //                 if (actionData[index].children[0].children.length > 0) {
    //                     actionData[index] = actionData[index].children[0].children[0]
    //                 } else {
    //                     actionData[index] = {};
    //                 }
    //                 setActions(actionData);
    //             }
    //         }
    //     }
    // }


    const addCondition = (fromChangeHasCondition) => {
        let c = [...conditions];
        if (c.length) {
            c[c.length - 1].logic = 'and';
        }
        const newCondition = {
            logic: "last",
            fields: {
                firstValue: {
                    value: ''
                },
                secondValue: {
                    value: ''
                },
                caseSensitive: {
                    value: false
                }
            },
            operator: "eq",
            condition: "string",
            firstBool: true,
            secondBool: true
        }
        c.push(newCondition);
        setConditions(c);
        if (fromChangeHasCondition) {
            return c;
        } else {
            setActionCondition(c);
        }

    }

    // set condition field in actions
    // const setActionCondition = (c) => {
    //     let actionData = [...actions]
    //     actionData[index].children[0].fields.conditions.value = c;
    //     setActions(actionData);
    // }

    const setActionCondition = (c) => {
        let _actions = [...actions]
        _actions[index].conditions = c;
        setActions(_actions);
    }

    // const removeCondition = (i) => {
    //     let c = [...conditions];
    //     c.splice(i, 1);
    //     c[c.length - 1].logic = 'last'
    //     setConditions(c)
    //     setActionCondition(c);
    // }

    const removeCondition = (i) => {
        let c = [...conditions];
        c.splice(i, 1);
        c[c.length - 1].logic = 'last'
        setConditions(c)
        setActionCondition(c);
    }

    // const updateAction = (value) => {
    //     setActionName(value);

    //     let actionData = [...actions];
    //     const data = changeSelectedAction(value);
    //     if (hasCondition) {
    //         if (actionData[index].children[0].children.length > 0) {
    //             actionData[index].children[0].children[0] = data;
    //         } else {
    //             actionData[index].children[0].children.push(data);
    //         }
    //     } else {
    //         actionData[index] = data;
    //     }

    //     setActions(actionData);
    // }


    const updateAction = (v) => {
        setActionName(v);

        let _actions = [...actions];
        let action = changeSelectedAction(v);

        if (hasCondition) {
            action.conditions = [...conditions];

            // if (actionData[index].children[0].children.length > 0) {
            //     actionData[index].children[0].children[0] = data;
            // } else {
            //     actionData[index].children[0].children.push(data);
            // }
        }

        _actions[index] = JSON.parse(JSON.stringify(action));

        setActions(_actions);
        setSelectedAction(action);
    }

    const removeAction = () => {
        console.log('index => ', index)
        let _actions = [...actions];
        _actions.splice(index, 1);
        setActions(_actions)
    }

    const handleLogicChange = (logic, i) => {
        let c = [...conditions];
        c[i].logic = logic;
        setConditions(c);
        setActionCondition(c);
    }

    // set action field
    // const setField = (inputName, value) => {
    //     let actionData = [...actions];
    //     if (hasCondition && actionData[index].children) {
    //         actionData[index].children[0].children[0].fields[inputName] = value;
    //     } else {
    //         actionData[index].fields[inputName] = value;
    //     }
    //     setActions(actionData)
    // }

    // set action field
    const setField = (inputName, v) => {
        let _actions = [...actions];
        _actions[index].fields[inputName] = v;
        setActions(_actions)
    }

    // set condition fields
    const setConditionField = (conditionIndex, fieldName, value) => {
        let c = [...conditions]
        if (fieldName === 'operator' || fieldName === 'condition') {
            c[conditionIndex][fieldName] = value;
        } else {
            c[conditionIndex].fields[fieldName] = value;
        }
        setConditions(c);
        setActionCondition(c);
    }

    const addAction = () => {
        let actionData = [...actions];
        actionData.push({});
        setActions(actionData)
    }

    return (
        <div className='object-explorer-action-container'>
            <div className='action-section-area'>
                <span className='action-count'>{index + 1}</span>
                <Select className='action-select-input' displayEmpty value={actionName} onChange={(e) => updateAction(e.target.value)} variant="outlined" IconComponent={(props) => (
                    <>
                        <span className='action-select' ></span>
                        <ExpandMoreIcon style={{ color: '#031226', position: 'relative', height: '15px', width: '15px' }} {...props} />
                    </>
                )}
                >

                    {
                        functionNames.filter(x => x.type === field.type).length < 1 ?
                            <MenuItem disabled key={""} value={""}>No action found for the selected type</MenuItem>
                            :
                            <MenuItem disabled value="">
                                <span className='font-manrope action-place-holder'>{t(label + 'SELECT-ACTION')}</span>
                            </MenuItem>
                    }
                    {
                        functionNames.filter(x => x.type === field.type).map((item, itemI) =>
                            <MenuItem key={itemI} value={item.value}>{item.label}</MenuItem>
                        )
                    }
                </Select>
                {
                    (index !== 0 || actions.length === 1) &&
                    <IconButton className='add-action-button' onClick={addAction}>
                        <AddBoxIcon fontSize='medium' />
                    </IconButton>
                }

                {
                    index !== 0 && (
                        <IconButton className='delete-action-button' onClick={removeAction}>
                            <IndeterminateCheckBoxOutlinedIcon />
                        </IconButton>
                    )
                }
            </div>
            <div>
                {
                    selectedAction && (
                        <ConfigurationForm disabled={true} outputVisible={true} setField={setField} selectedAction={selectedAction}
                            variables={variables}
                            setOpenVariable={setOpenVariable} variableRender={variableRender} />
                    )
                }
            </div>
            {
                selectedAction && <div style={{ marginBottom: '2%' }}>
                    <FormControlLabel
                        control={<GreenCheckbox name="checkedG" checked={hasCondition}
                            onChange={(e) => changeHasCondition(e.target.checked)} />}
                        label={t(label + 'CONDITION-QUESTION')}
                    />
                    {
                        hasCondition && <IconButton color={'black'} onClick={() => addCondition(false)}>
                            <AddCircleIcon />
                        </IconButton>
                    }
                </div>
            }
            {
                hasCondition &&
                conditions.map((conditionInfo, conditionIndex) => (
                    <div key={conditionIndex}>
                        <Card style={{ backgroundColor: 'var(--black-pearl)', boxShadow: 'none' }}>
                            <CardHeader className={classes.header} titleTypographyProps={{ variant: '' }}
                                title={`${t(label + 'CONDITION')} # ${conditionIndex + 1}`}
                                action={
                                    conditionIndex !== 0 && <IconButton style={{ color: 'white' }}
                                        onClick={() => removeCondition(conditionIndex)}>
                                        <DeleteOutlineOutlinedIcon />
                                    </IconButton>
                                }
                            />
                            <CardContent style={{ backgroundColor: '#ebecee' }}>
                                <Condition conditionBackup={conditionBackup} conditionInfo={conditionInfo}
                                    variables={variables} setOpenVariable={setOpenVariable}
                                    variableRender={variableRender} setField={(key, value) => {
                                        setConditionField(conditionIndex, key, value)
                                    }} />
                            </CardContent>
                        </Card>
                        {
                            conditionInfo.logic !== 'last' &&
                            <div className="form-element" style={{ textAlign: 'center' }}>
                                <div className="condition-tabs">
                                    <button className={conditionInfo.logic === 'and' ? 'condition-active' : ''}
                                        value="and" onClick={(e) => {
                                            handleLogicChange('and', conditionIndex)
                                        }}>
                                        {t(label + 'AND')}
                                    </button>
                                    <button className={conditionInfo.logic === 'or' ? 'condition-active' : ''}
                                        value="or" onClick={(e) => {
                                            handleLogicChange('or', conditionIndex)
                                        }}>
                                        {t(label + 'OR')}
                                    </button>
                                </div>
                            </div>
                        }
                    </div>
                ))
            }
        </div>
    )
}

export default Action;
